import React from "react";
import PropTypes from "prop-types";
import Icon from "components/library/Icon";

import styles from "./NewsletterChunkButton.css";

export default function NewsletterChunkButton(props) {
  return (
    <div className={styles.root}>
      <button
        className={styles.button}
        disabled={props.isDisabled}
        // for reasons unknown, if this button is pressed while another chunk's editor is active
        // it will not receive the onClick event. onMouseDown and onKeyDown are provided
        // as replacements.
        onMouseDown={props.onClick}
        onKeyDown={e => {
          // handle spacebar event
          if (e.keyCode == 32) {
            props.onClick(e);
          }
        }}
        data-cy="addChunk"
      >
        <Icon name="add" className={styles.icon} />
      </button>
    </div>
  );
}

NewsletterChunkButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};
